import { render } from "./UserTable.vue?vue&type=template&id=10818b72&scoped=true"
import script from "./UserTable.vue?vue&type=script&lang=js"
export * from "./UserTable.vue?vue&type=script&lang=js"

import "./UserTable.vue?vue&type=style&index=0&id=10818b72&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10818b72"]])

export default __exports__